<template>
  <div class="content_period">
    <input id="klickbox-filter-period" class="btn-period" type="checkbox">
    <label for="klickbox-filter-period" class="kp-button kp-button__min btn-gray">
      {{ $t('report.individual.date_filter') }}
    </label>
    <div class="period">
      <h3 class="period-title">{{ $t('report.individual.date_range') }}:</h3>
      <label>{{ $t('report.individual.from') }}</label>
      <datepicker
        :format="format"
        v-on:selected="selectedDateFrom"
        language="pt-br"
        placeholder="dd/mm/aaaa">
      </datepicker>
      <label>{{ $t('report.individual.to') }}</label>
      <datepicker
        :format="format"
        v-on:selected="selectedDateTo"
        language="pt-br"
        placeholder="dd/mm/aaaa">
      </datepicker>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      format: 'dd/MM/yyyy',
    };
  },
  methods: {
    selectedDateFrom(value) {
      this.$store.dispatch('reportSetPage', null);
      this.$store.dispatch('reportSetDateFrom', `${value.toLocaleDateString('pt-br')} 00:00:00`);
      this.$store.dispatch('reportSetAnswers');
    },
    selectedDateTo(value) {
      this.$store.dispatch('reportSetPage', null);
      this.$store.dispatch('reportSetDateTo', `${value.toLocaleDateString('pt-br')} 23:59:59`);
      this.$store.dispatch('reportSetAnswers');
    },
    ...mapActions([
      'reportSetPageId',
      'reportSetDateFrom',
      'reportSetDateTo',
      'reportSetAnswers',
    ]),
  },
};
</script>




/** WEBPACK FOOTER **
 ** DateFilter.vue?f558921a
 **/